/* Djurslottet: image lightbox = no pinch/drag zoom; VERTICAL scroll on ALL sizes
   (mobile & desktop), NO arrows, a 'scroll for more' hint, and the thumbnails
   highlight/scroll to follow the image you've scrolled to. Also syncs the main
   product gallery to the image you closed on. Disables the theme drag-zoom-wrapper
   PERSISTENTLY (MutationObserver + click burst) so mobile vertical scroll never
   gets blocked by its preventDefault touch listeners. DESKTOP: one click on any
   empty (white) area outside the image closes the lightbox. No core-theme files touched. */
(function () {
  function killZoom() {
    var list = document.querySelectorAll('drag-zoom-wrapper');
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      try { if (typeof w.destroy === 'function') { w.destroy(); } } catch (e) {}
      try {
        w.style.touchAction = 'pan-y';
        w.style.setProperty('--drag-zoom-scale', '1');
        w.style.setProperty('--drag-zoom-translate-x', '0px');
        w.style.setProperty('--drag-zoom-translate-y', '0px');
      } catch (e) {}
    }
  }
  function killBurst() {
    killZoom();
    try { requestAnimationFrame(killZoom); } catch (e) {}
    [40, 120, 260, 500, 900].forEach(function (t) { setTimeout(killZoom, t); });
  }

  function ctx() {
    var zd = document.querySelector('zoom-dialog');
    if (!zd) return null;
    var dialog = zd.querySelector('dialog');
    var gallery = zd.querySelector('.dialog-zoomed-gallery');
    var items = gallery ? Array.prototype.slice.call(gallery.children) : [];
    return { zd: zd, dialog: dialog, gallery: gallery, items: items };
  }

  function currentIndex(c) {
    if (!c.items.length) return 0;
    var cy = window.innerHeight / 2, best = 0, bd = Infinity;
    for (var k = 0; k < c.items.length; k++) {
      var r = c.items[k].getBoundingClientRect();
      if (!r.height) continue;
      var m = (r.top + r.bottom) / 2, d = Math.abs(m - cy);
      if (d < bd) { bd = d; best = k; }
    }
    return best;
  }

  function thumbList(c) { return c.zd ? c.zd.querySelectorAll('.dialog-thumbnails-list__thumbnail') : []; }

  function syncThumb(c) {
    var ts = thumbList(c);
    if (!ts.length) return;
    var idx = currentIndex(c);
    for (var i = 0; i < ts.length; i++) ts[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
    var t = ts[idx];
    if (t) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
  }

  function navMain(idx) {
    if (idx < 0) return;
    var mg = document.querySelector('media-gallery');
    if (!mg) return;
    var controls = mg.querySelector('.slideshow-controls');
    var thumbs = controls ? controls.querySelectorAll('.slideshow-controls__thumbnail') : null;
    if (thumbs && thumbs[idx]) { try { thumbs[idx].click(); return; } catch (e) {} }
    var scroller = mg.querySelector('slideshow-slides');
    if (scroller && scroller.clientWidth) {
      try { scroller.scrollTo({ left: idx * scroller.clientWidth, behavior: 'instant' }); } catch (e) {}
    }
  }

  function injectHint(c) {
    if (!c.dialog || c.items.length < 2) return;
    if (c.dialog.querySelector('.dj-zf__hint')) return;
    var h = document.createElement('div');
    h.className = 'dj-zf__hint';
    h.innerHTML = '<span>Bläddra för fler bilder</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    c.dialog.appendChild(h);
  }

  function onScroll(c) {
    if (!c || !c.gallery || !c.dialog) return;
    var scrolled = c.gallery.scrollTop > 24;
    var hint = c.dialog.querySelector('.dj-zf__hint');
    if (hint) hint.style.opacity = scrolled ? '0' : '1';
    c.dialog.classList.toggle('dj-zf-scrolled', scrolled);
    syncThumb(c);
  }

  function bindEvents(c) {
    if (c.gallery && !c.gallery.__djScrollBound) {
      c.gallery.__djScrollBound = true;
      c.gallery.addEventListener('scroll', function () { onScroll(ctx()); }, { passive: true });
    }
    if (c.dialog && !c.dialog.__djThumbBound) {
      c.dialog.__djThumbBound = true;
      c.dialog.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('.dialog-thumbnails-list__thumbnail') : null;
        if (!t) return;
        var cc = ctx(); if (!cc) return;
        var list = Array.prototype.slice.call(thumbList(cc));
        var idx = list.indexOf(t);
        if (idx < 0 || !cc.items[idx]) return;
        var el = cc.items[idx];
        var top = cc.gallery.scrollTop + (el.getBoundingClientRect().top - cc.gallery.getBoundingClientRect().top);
        if (top < 0) top = 0;
        try { cc.gallery.scrollTo({ top: top, behavior: 'instant' }); } catch (er) { cc.gallery.scrollTop = top; }
      });
    }
  }

  // DESKTOP: a single click on any empty (white) area outside the image closes the
  // lightbox (calls the native dialog.close(), which is what actually closes it,
  // after syncing the main gallery). Clicks on the image/thumbnails/buttons/close are ignored.
  var IGNORE = '.product-media__image, img, picture, video, iframe, deferred-media, .deferred-media, .deferred-media__poster-image, .dialog-thumbnails-list__thumbnail, .dialog-thumbnails-list-container, button, a, .dj-zf__arrow, .dj-zf__hint';
  function bindBackdropClose(c) {
    if (!c.dialog || c.dialog.__djBackClose) return;
    c.dialog.__djBackClose = true;
    c.dialog.addEventListener('click', function (e) {
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return; // desktop only
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(IGNORE)) return;
      var cc = ctx();
      try { if (cc) navMain(currentIndex(cc)); } catch (e2) {}
      try { (cc && cc.dialog ? cc.dialog : c.dialog).close(); } catch (e3) {}
    });
  }

  function wrapClose() {
    var c = ctx();
    if (!c || !c.zd) return;
    var zd = c.zd;
    if (zd.__djCloseWrapped) return;
    if (typeof zd.close !== 'function') return;
    zd.__djCloseWrapped = true;
    var orig = zd.close.bind(zd);
    zd.close = function () {
      try { var cc = ctx(); if (cc) navMain(currentIndex(cc)); } catch (e) {}
      return orig.apply(this, arguments);
    };
  }

  function setup() {
    killZoom();
    wrapClose();
    var c = ctx();
    if (!c || !c.gallery) return;
    injectHint(c);
    bindEvents(c);
    bindBackdropClose(c);
    onScroll(c);
  }

  var n = 0;
  var iv = setInterval(function () { setup(); if (++n > 20) { clearInterval(iv); } }, 300);
  if (document.readyState !== 'loading') { setup(); }
  else { document.addEventListener('DOMContentLoaded', setup); }

  var mo = new MutationObserver(function () {
    if (mo._t) return;
    mo._t = setTimeout(function () { mo._t = null; setup(); }, 80);
  });
  try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.product-media__image, media-gallery .product-media, zoom-dialog')) killBurst();
  }, true);
})();
